import React, { Component} from 'react'
import { Link } from 'react-router-dom'
import FaqList from "./FaqList";
import history from "../../route/history";
const Faq = props => {

    const prePage = (e) => {
        e.preventDefault();
        window.history.back()
      }

    return(
        <React.Fragment>
        <main>
            <div id="contents">
                <div className='content-header'>
                    <a onClick={prePage} className="page-prev">뒤로이동</a> {/* mobile */}
                    <h2>FAQ</h2>
                    <div className="breadcrumb">
                    <span>Home</span><span>고객센터</span><em>FAQ</em>
                    </div>
                </div>

                <div className="notice-tab">
                    <ul className='nav-tab mt40'>
                        <li><Link title="공지사항" to="/notice">공지사항</Link></li>
                        <li className="on"><Link title="FAQ" to="/faq">FAQ</Link></li>
                        <li><Link title="문의하기" to="/question">문의하기</Link></li>
                        <li><Link title="자료실" to="/reference">자료실</Link></li>
                        <li><Link title="이용안내" to="/guide">이용안내</Link></li>
                    </ul> 
                </div>
                <FaqList search={props.location?.search}/>
            </div>
        </main>
        </React.Fragment>
    )

}


export default Faq

